import Vue from 'vue';
import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);

export default VueCountdownTimer;
